'use strict';

const { default: i18next } = require('i18next');

module.exports = function i18n(str, options) {
  return (undefined !== i18next) ? i18next.t(str, options.hash) : str;
};
